import UserRole from "../../../../../common/types/user-role";
import UserPermissions from "../../../../../common/utils/user/permissions/user-permissions";
import UserPermissionsDefinition from "../../../../../common/utils/user/permissions/user-permissions-definition";

export type RouteActiveListingUserPermissionOption =
  | "hasAccessToTaxiCorporation";

export type RouteActiveListingUserPermissionsDefinition =
  UserPermissionsDefinition<RouteActiveListingUserPermissionOption>;

export type RouteActiveListingUserPermissions =
  UserPermissions<RouteActiveListingUserPermissionOption>;

const routeActiveListingUserPermissionDefinition: RouteActiveListingUserPermissionsDefinition =
  {
    hasAccessToTaxiCorporation: [UserRole.ADMIN, UserRole.OPERATOR],
  };

export default routeActiveListingUserPermissionDefinition;
